import { HttpMethod } from '@pool-league/shared-util-http';
import {
  EndpointPathParameters,
  GetOperation,
  PatchOperation,
  PostOperation,
} from '../operation';

export type SeasonByIdPath = EndpointPathParameters<'seasonId'>;
export const UPDATE_SEASON: PatchOperation<keyof SeasonByIdPath> = {
  path: ['seasons', { param: 'seasonId' }],
  method: HttpMethod.PATCH,
};

export const GET_SEASONS: GetOperation<void> = {
  path: ['seasons'],
  method: HttpMethod.GET,
};

export const CREATE_SEASON: PostOperation<void> = {
  path: ['seasons'],
  method: HttpMethod.POST,
};
